import { render } from "./AboutUs.vue?vue&type=template&id=e75d60e4&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=e75d60e4&scoped=true&lang=css"

import exportComponent from "/home/jk/htdocs/vue/mlcc/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75d60e4"]])

export default __exports__